module.exports = __webpack_public_path__ + "media/vdrax_home.9919a146.mp4";